import React, { useState, useRef } from 'react';
import { TextField, InputAdornment, Box, ClickAwayListener, IconButton } from '@mui/material';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import CloseIcon from '@mui/icons-material/Close';
import DateRangeCalendar from './DateRange';
import './CustomCalendar.scss';

const DateRangePicker = ({dateRange, setDateRange}) => {
    const [isOpen, setIsOpen] = useState(false);
   
    const calendarRef = useRef(null);

    const formatDate = (date) => {
        if (!date) return '';
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const handleDateRangeSelect = (startDate, endDate) => {
        setDateRange({ startDate, endDate });
        setIsOpen(false);
    };

    const handleClearDates = (event) => {
        event.stopPropagation(); // Prevent opening calendar when clearing
        setDateRange({ startDate: null, endDate: null });
    };

    const displayValue = dateRange.startDate && dateRange.endDate
        ? `${formatDate(dateRange.startDate)} ~ ${formatDate(dateRange.endDate)}`
        : '';

    const handleClickAway = (event) => {
        if (calendarRef.current && !calendarRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Box ref={calendarRef} sx={{ position: 'relative', width: '100%' }}>
                <TextField
                    value={displayValue}
                    placeholder="YYYY-MM-DD ~ YYYY-MM-DD"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {displayValue ? (
                                    <IconButton
                                        size="small"
                                        onClick={handleClearDates}
                                        sx={{ 
                                            padding: '4px',
                                            '&:hover': {
                                                backgroundColor: 'transparent'
                                            }
                                        }}
                                    >
                                        <CloseIcon sx={{ 
                                            fontSize: 20,
                                            cursor: 'pointer',
                                            color: '#666'
                                        }} />
                                    </IconButton>
                                ) : (
                                    <DateRangeOutlinedIcon
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => setIsOpen(!isOpen)}
                                    />
                                )}
                            </InputAdornment>
                        ),
                        readOnly: true,
                    }}
                    sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: 'white',
                            },
                            '&:hover fieldset': {
                                borderColor: 'white',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'white',
                            },
                        },
                    }}
                    onClick={() => setIsOpen(!isOpen)}
                />
                {isOpen && (
                    <Box sx={{
                        position: 'absolute',
                        top: '100%',
                        right: '180%',
                        zIndex: 1000,
                        mt: 1,
                    }}>
                        <DateRangeCalendar
                            initialStartDate={dateRange.startDate}
                            initialEndDate={dateRange.endDate}
                            onDateRangeSelect={handleDateRangeSelect}
                            onClose={() => setIsOpen(false)}
                        />
                    </Box>
                )}
            </Box>
        </ClickAwayListener>
    );
};

export default DateRangePicker;